import Lang from '../lang/sms-en';

export default {
  mixin: [Lang],
  methods: {
    validateStatus(validation, formField) {
      let validationRules = [];
      validationRules = {
        invalid: validation.$invalid,
        dirty: validation.$dirty,
        errors: [],
      };
      Object.entries(validation.$params).forEach((key) => {
        const type = key[0];
        const params = validation.$params;
        validationRules.errors.push({
          type,
          status: validation[type],
          message: this.getErrorMessage(params, formField, type),
        });
      });
      return validationRules;
    },
    getErrorMessage(params, formField, type) {
      return Lang.formValidation[type](formField, params[type]);
    },
  },
};
